import React, { useEffect, useState, useRef } from "react";
import { SlTab, SlTabGroup, SlTabPanel, SlDrawer } from "@shoelace-style/shoelace/dist/react";
import PendingRequests from "./PendingRequests";
import RejectedRequest from "./RejectedRequest";
import ApprovedRequests from "./ApprovedRequests";
import { useTableState } from "../Designer/utils/useTableState";
import api from "../../services/api";
import config from "../../config";

const MakerCheckerReports = () =>{
    
  const getDefaultRole = () => {
    const mcRole = Number(localStorage.getItem('mc_role'));
    if (mcRole === 3) return "checker";
    return null;
  };
    const [data,setdata] = useState(0);
    const [totalPending, settotalPending] = useState(0);
    const [totalApproved, settotalApproved] = useState(0);
    const [totalRejected, settotalRejected] = useState(0);
    const [currentChild, setCurrentChild] = useState("request-pending");
    const [activeRole, setActiveRole] = useState(getDefaultRole);
    const [loader,setLoader] = useState(false);
    const { currentPage, setCurrentPage, handlePageChange } = useTableState();
    const tabGroupRef = useRef(null);
    
    const handleTabSwitch = (panelName) => {
      tabGroupRef.current?.show(panelName);
    };

    const handleRoleChange = (e) => {
      const selectedRole = e.target.value;
      setActiveRole(selectedRole);
    };

    const getPendingRequests = async (page) => {
        setLoader(true);
        try {
          const res = await api({ url: `/makerchecker/getPendingRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
          if (res.code === 200) setdata(res?.data);
        } catch (error) {}
        setLoader(false);
    };
    const getApprovedRequests = async (page) => {
        setLoader(true);
        try {
          const res = await api({ url: `/makerchecker/getApprovedRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
          if (res.code === 200) setdata(res?.data);
        } catch (error) {}
        setLoader(false);
    };
    const getRejectedRequests = async (page) => {
        setLoader(true);
        try {
          const res = await api({ url: `/makerchecker/getRejectedRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
          if (res.code === 200) setdata(res?.data);
        } catch (error) {}
        setLoader(false);
    };
    const getMakerPendingRequests = async (page) => {
      setLoader(true);
      try {
        const res = await api({ url: `/makerchecker/getMakerPendingRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
        if (res.code === 200) setdata(res?.data);
      } catch (error) {}
      setLoader(false);
    };
    const getMakerApprovedRequests = async (page) => {
        setLoader(true);
        try {
          const res = await api({ url: `/makerchecker/getMakerApprovedRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
          if (res.code === 200) setdata(res?.data);
        } catch (error) {}
        setLoader(false);
    };
    const getMakerRejectedRequests = async (page) => {
        setLoader(true);
        try {
          const res = await api({ url: `/makerchecker/getMakerRejectedRequests`, method: "POST", data: { page, limit: config.PER_PAGE } });
          if (res.code === 200) setdata(res?.data);
        } catch (error) {}
        setLoader(false);
    };
    const totalCount = async () => {
      try {
        const res = await api({ url: `/makerchecker/getTotalCount`, method: "POST", data: {} });
        if (res.code === 200) {
          settotalPending(res.data.pending || 0);
          settotalApproved(res.data.approved || 0);
          settotalRejected(res.data.rejected || 0);
        }
      } catch (error) {}
    };
    const makertotalCount = async () => {
      try {
        const res = await api({ url: `/makerchecker/getMakerTotalCount`, method: "POST", data: {} });
        if (res.code === 200) {
          settotalPending(res.data.pending || 0);
          settotalApproved(res.data.approved || 0);
          settotalRejected(res.data.rejected || 0);
        }
      } catch (error) {}
    };
    // useEffect(()=>{
    //   if(localStorage.getItem('mc_role') == 3)
    //     setActiveRole("checker")
    // },[])
    useEffect(() => {
        if (currentChild === "request-pending" && (activeRole === "checker" || localStorage.getItem('mc_role') == 2)) getPendingRequests(currentPage);
        else if (currentChild === "request-approved" && (activeRole === "checker" || localStorage.getItem('mc_role') == 2)) getApprovedRequests(currentPage);
        else if(currentChild === "request-rejected" && (activeRole === "checker" || localStorage.getItem('mc_role') == 2)) getRejectedRequests(currentPage);
        else if (currentChild === "request-pending" && (activeRole === "maker" || localStorage.getItem('mc_role') == 1)) getMakerPendingRequests(currentPage);
        else if (currentChild === "request-approved" &&  (activeRole === "maker" || localStorage.getItem('mc_role') == 1)) getMakerApprovedRequests(currentPage);
        else if(currentChild === "request-rejected" && (activeRole === "maker" || localStorage.getItem('mc_role') == 1)) getMakerRejectedRequests(currentPage)
    }, [currentChild, currentPage,activeRole]);
    useEffect(() => {
      if((activeRole === "checker" || localStorage.getItem('mc_role') == 2))
      totalCount();
      else if((activeRole === "maker" || localStorage.getItem('mc_role') == 1))
      makertotalCount();
    }, [currentChild,activeRole]);
    return(
        <div className="p-4">
        {localStorage.getItem('mc_role') == 3 && (
        <div className="flex items-center gap-4 mb-4">
          <label className="font-semibold">Choose Role:</label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="roleSelect"
              value="maker"
              checked={activeRole === "maker"}
              onChange={handleRoleChange}
            />
            Maker
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="roleSelect"
              value="checker"
              checked={activeRole === "checker"}
              onChange={handleRoleChange}
            />
            Checker
          </label>
        </div>
        )}
        <SlTabGroup  ref={tabGroupRef} onSlTabShow={(event) => setCurrentChild(event.detail.name)}>
        <SlTab slot="nav" panel="request-pending">
          Pending Requests <span className="text-blue-600 mx-1">{totalPending || 0}</span>
        </SlTab>
        <SlTab slot="nav" panel="request-approved">
          Approved Requests<span className="text-blue-600 mx-1">{totalApproved || 0}</span>
        </SlTab>
        <SlTab slot="nav" panel="request-rejected">
          Rejected Requests <span className="text-blue-600 mx-1">{totalRejected || 0}</span>
        </SlTab>
        <SlTabPanel name="request-pending">
            <PendingRequests
            data={data}
            totalPending={totalPending}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader={loader}
            getPendingRequests={getPendingRequests}
            handleTabSwitch={handleTabSwitch}
            activeRole={activeRole}
            />
        </SlTabPanel>
        <SlTabPanel name="request-approved">
            <ApprovedRequests
            data={data}
            totalApproved={totalApproved}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader={loader}
            activeRole={activeRole}
            />
        </SlTabPanel>
        <SlTabPanel name="request-rejected">
            <RejectedRequest
            data={data}
            totalRejected={totalRejected}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader={loader}
            activeRole={activeRole}
            />
        </SlTabPanel>
        </SlTabGroup>
        </div>
    )
}
export default MakerCheckerReports;